<template>
  <div
    id="content-navigation"
    class="d-flex flex-column flex-grow-1">
    <!-- Content Section Navigation -->
    <nav class="mb-3">
      <h3 class="px-5 mb-3">Section</h3>
      <v-btn
        class="plain py-2 px-5 justify-start"
        to="/content/all"
        block>
        <v-icon class="mx-5">mdi-text-box-multiple-outline</v-icon>
        All
      </v-btn>
      <v-btn
        v-for="contentGroup in contentGroups"
        :key="contentGroup"
        :to="`/content/${contentGroup.toLowerCase()}`"
        class="plain py-2 px-5 justify-start"
        block>
        <v-icon class="mx-5">mdi-text-box-outline</v-icon>
        {{contentGroup | startCase}}
      </v-btn>
    </nav>
    <!-- / Content Section Navigation -->

    <!-- Content Type Navigation -->
    <nav class="mb-3">
      <h3 class="px-5 mb-3">Type</h3>
      <v-btn
        class="plain py-2 px-5 justify-start"
        to="/content/text"
        block>
        <v-icon class="mx-5">mdi-text-box-multiple-outline</v-icon>
        Text
      </v-btn>
      <v-btn
        class="plain py-2 px-5 justify-start"
        to="/content/image"
        block>
        <v-icon class="mx-5">mdi-image-multiple-outline</v-icon>
        Image
      </v-btn>
      <v-btn
        class="plain py-2 px-5 justify-start"
        to="/content/colors"
        block>
        <v-icon class="mx-5">mdi-palette</v-icon>
        Colors
      </v-btn>
    </nav>
    <!-- / Content Type Navigation -->

    <v-spacer></v-spacer>

    <!-- Preview / Publish -->
    <PreviewPublish />
    <!-- / Preview / Publish -->
  </div>
</template>

<script>
import ContentItemMixin from '../mixin.content-item';
import PreviewPublish from './PreviewPublish.vue';

export default {
  name: 'ContentNavigation',
  mixins: [
    ContentItemMixin,
  ],
  components: {
    PreviewPublish,
  },
};
</script>

<style lang="scss"></style>
